import React from 'react';
import loadable from '@loadable/component';
import LoadingScreen from 'components/LoadingScreen';

const LoadableCardChoice = loadable(() => import('./CardChoice'), {
  fallback: <LoadingScreen />,
});

export default LoadableCardChoice;
